import { useEmbedStatus } from "../hooks/useEmbedStatus";
import { useAffiliate } from "../hooks/useAffiliate";
import { ThemeIntegrationBar } from "./welcome/ThemeIntegrationBar";
import { WelcomeBanner } from "./welcome/WelcomeBanner";
import { BetaBanner } from "./welcome/BetaBanner";
import { WelcomePageSkeleton } from "./welcome/WelcomePageSkeleton";
import { SetupGuide } from "./welcome/SetupGuide";
import { PlanSection } from "./welcome/PlanSection";
import { AccountSettings } from "./welcome/AccountSettings";

const WelcomePage = () => {
  const { enabled, loading } = useEmbedStatus();
  // Single affiliate state shared by both sections so redeeming in the affiliate
  // card immediately reflects the bonus in "Tu plan" — no page refresh needed.
  const affiliate = useAffiliate();

  return (
    <s-page heading="Bienvenido">
      {loading ? (
        <WelcomePageSkeleton />
      ) : (
        <>
          <ThemeIntegrationBar loading={loading} enabled={enabled} />
          <WelcomeBanner />
          <s-box padding="base" />
          <BetaBanner />
          <s-box padding="base" />
          <SetupGuide enabled={enabled} />
          <s-box padding="base" />
          <PlanSection affiliateStatus={affiliate.status} />
          <s-box padding="base" />
          <AccountSettings affiliate={affiliate} />
        </>
      )}
    </s-page>
  );
};

export default WelcomePage;
